import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

// Utils
import { useAppContext } from '../../../store/AppContext';
import cn from '../../../utils/cn';

import styles from './PageSection.module.scss';

function PageSection({
  index, title, icon, children,
}) {
  const sectionRef = useRef();
  const [{ activeTab }] = useAppContext();

  useEffect(() => {
    if (activeTab === index && sectionRef?.current) {
      const top = sectionRef.current.offsetTop;
      window.scrollTo(0, activeTab === 0 ? 0 : top - 20);
    }
  }, [activeTab]);

  return (
    <div ref={sectionRef} className={cn([styles.section, 'm-b-30 p-b-30'])}>
      {title ? (
        <h2 className={cn([styles.title, 'd-flex a-center'])}>
          {icon ? (
            <span className={cn([styles.icon, 'd-flex center m-r-10'])}>{icon}</span>
          ) : null}
          <span className="font-secondary fs-24 fw-500 c-neutral-01">{title}</span>
        </h2>
      ) : null}

      <div className={cn([styles.block, 'm-t-10'])}>
        {children}
      </div>
    </div>
  );
}

PageSection.propTypes = {
  index: PropTypes.number.isRequired,
  title: PropTypes.string,
  icon: PropTypes.node,
  children: PropTypes.node,
};

PageSection.defaultProps = {
  title: null,
  icon: null,
  children: null,
};

export default PageSection;
